import { Typography, Box, Grid } from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Minimize from '@material-ui/icons/Minimize';
import AddIcon from '@material-ui/icons/Add';
import React, { useState } from 'react';
import lock from "../../../images/icon_lock.png";

const PatientProfilePregnancy = props => {

    const [expandedPanel, setExpandedPanel] = useState([]);


    const handleAccordionChange = (allPanels, panel, setter) => (event, isExpanded) => {
        if (isExpanded) {
            let panels = [...allPanels];
            panels.push(panel)
            setter(panels);
        }
        else {
            let panelsList = [...allPanels];
            let index = panelsList.indexOf(panel)
            panelsList.splice(index, 1)
            setter(panelsList)
        }
    };

    let providerViewPregnancies = 0;


    return (
        <Grid  >
            {
                props.pregnancies.map((prenancie, i) => {
                    return (
                        <Box style={{ display: "block", marginTop: "10px" }}>
                            {prenancie.isProviderView == 'true' ?

                                <Accordion onChange={handleAccordionChange(expandedPanel, i, setExpandedPanel)}>
                                    <AccordionSummary
                                        expandIcon={
                                            expandedPanel.some(x => x === i) ? <Minimize /> :
                                                <AddIcon />
                                        }>
                                        <Typography>
                                            Pregnancy {providerViewPregnancies = providerViewPregnancies + 1}  ({prenancie.year - props.dateOfBirthYear})
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <Box style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                                            <Box style={{ width: "20%" }}>
                                                <Box style={{ display: "flex", justifyContent: "center" }}>
                                                    <b>Year</b>
                                                </Box>
                                                <Box style={{ display: "flex", justifyContent: "center" }}>
                                                    {prenancie.year}
                                                </Box>
                                            </Box>
                                            <Box style={{ width: "20%" }}>
                                                <Box style={{ display: "flex", justifyContent: "center" }}>
                                                    <b>Intention</b>
                                                </Box>
                                                <Box style={{ display: "flex", justifyContent: "center" }}>
                                                    {prenancie.intention}
                                                </Box>
                                            </Box>
                                            <Box style={{ width: "20%" }}>
                                                <Box style={{ display: "flex", justifyContent: "center" }}>
                                                    <b>Outcome</b>
                                                </Box>
                                                <Box style={{ display: "flex", justifyContent: "center" }}>
                                                    {prenancie.outcome}
                                                </Box>
                                            </Box>
                                            <Box style={{ width: "20%" }}>
                                                <Box style={{ display: "flex", justifyContent: "center" }}>
                                                    <b>Live Birth</b>
                                                </Box>
                                                <Box style={{ display: "flex", justifyContent: "center" }}>
                                                    {prenancie.liveBirthQty}
                                                </Box>
                                            </Box>
                                        </Box>
                                    </AccordionDetails>
                                </Accordion>
                                : ""
                            }
                        </Box>
                    )
                })
            }
        </Grid>
    )
}



export default PatientProfilePregnancy;